module.exports = __webpack_public_path__ + "public/SideMenuIcons/siteSetting.svg?1c91e26c";